import { Elements } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CheckoutForm from "@/pages/checkout/CheckoutForm";
import CardWrapper from "@/components/card/CardWrapper";
import "@/styles/pages/checkout/checkout.scss";
import { jwtDecode } from "jwt-decode";

const Checkout = (props) => {
  const { stripePromise } = props;
  const { state } = useLocation();
  const { clientSecret: stateClientSecret = "" } = state ?? {};
  const [clientSecret, setClientSecret] = useState(stateClientSecret);
  const appearance = { theme: "stripe" };

  useEffect(() => {
    if (!stateClientSecret) {
      const urlParams = new URLSearchParams(window.location.search);
      const encryptedCode = urlParams.get("data");

      if (encryptedCode) {
        try {
          const decoded = jwtDecode(encryptedCode);
          console.log("Decoded Data:", decoded);

          if (decoded?.paymentToken) {
            setClientSecret(decoded.paymentToken);
          }
        } catch (error) {
          console.error("Failed to decode token:", error);
        }
      }
    }
  }, [stateClientSecret]);

  return (
    <div className="checkout-form-wrapper">
      <CardWrapper
        className="card-padding"
        style={{
          backgroundColor: "#fff5f0",
          color: "#db5800",
          fontWeight: "500",
          fontSize: "18px",
          lineHeight: "28px",
          padding: "16px 24px",
          marginBottom: "1rem",
        }}
      >
        <p>
          <strong>Note: </strong>
          Please ensure international payments are enabled on your card for a smooth checkout.
          Contact your bank if needed.
        </p>
      </CardWrapper>
      <CardWrapper className="card-padding">
        {clientSecret && stripePromise && (
          <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
            <CheckoutForm />
          </Elements>
        )}
      </CardWrapper>
    </div>
  );
};

export default Checkout;
